import { environment } from './../../../environments/environment';
import { Dashboard } from '../interceptors/token.interceptors';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JefeDirectoAusentismoService {
  public headers: HttpHeaders = new HttpHeaders({}).set(Dashboard, 'Dashboard');

  constructor(private _http: HttpClient) {}

  getRegistrosAusentismo(current_page: number, form: ausentiosmoFilters) {
    const params =
      `?paginate=1` +
      `&page=${current_page || 1}` +
      (form.tipo_ausencia ? `&tipo_ausencia=${form.tipo_ausencia}` : '') +
      (form.motivo_ausencia ? `&motivo_ausencia=${form.motivo_ausencia}` : '') +
      (form.estado ? `&estado=${form.estado}` : '') +
      (form.cedula ? `&cedula=${form.cedula}` : '') +
      (form.nombre ? `&nombre=${form.nombre}` : '') +
      (form.fecha_inicio ? `&fecha_inicio=${form.fecha_inicio} 00:00` : '') +
      (form.fecha_fin ? `&fecha_fin=${form.fecha_fin} 23:59` : '');

    return this._http.get(environment.ausentismo.GET_TODAS_SOLICITUDES_DE_ASUSENTISMO_PARA_JEFE_INDMEDIATO + params, {
      headers: this.headers,
    });
  }

  postResponderSolicitudAusentismo(res: resAusentismo) {
    return this._http.post(environment.ausentismo.POST_RESPONDER_SOLICITUD_AUSENTISMO_JEFE_INMEDIATO, res, {
      headers: this.headers,
    });
  }
}

export interface ausentiosmoFilters {
  tipo_ausencia: string;
  motivo_ausencia: string;
  estado: string;
  cedula: number;
  nombre: string;
  fecha_inicio: string;
  fecha_fin: string;
}

export interface resAusentismo {
  id_registro_ausentismo: number;
  estado: number;
}
